<template>
  <v-dialog v-model="dialog" max-width="440" persistent>
    <v-card>
      <v-card-title>Registrar número na Meta</v-card-title>
      <v-card-text>
        <v-alert v-if="error" type="error" dense class="mb-3">{{ error }}</v-alert>
        <p class="text-body-2 mb-3">
          Informe o PIN de verificação em duas etapas do WhatsApp Business (6 dígitos).
          Se o número ainda não tinha 2FA, este PIN será definido agora.
          Se o número já estiver CONNECTED na Meta, use "Sincronizar conta" para
          atualizar o status sem PIN.
        </p>
        <v-text-field
          v-model="pin"
          label="PIN (6 dígitos)"
          type="password"
          maxlength="6"
          counter="6"
          outlined
          dense
          autofocus
          :disabled="saving"
          @keyup.enter="submit"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">Cancelar</v-btn>
        <v-btn color="primary" :loading="saving" @click="submit">
          Registrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MESSAGER from "@/services/admin/messager.js";

export default {
  name: "MetaRegisterDialog",
  props: {
    value: { type: Boolean, default: false },
    account: { type: Object, default: null },
  },
  data: () => ({
    pin: "",
    saving: false,
    error: null,
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.pin = "";
        this.error = null;
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    async submit() {
      const pin = this.pin.trim();
      if (!/^\d{6}$/.test(pin)) {
        this.error = "Informe um PIN válido com 6 dígitos";
        return;
      }
      try {
        this.saving = true;
        this.error = null;
        await MESSAGER.accounts.register(this.account.id, { pin });
        this.close();
        this.$emit("registered");
      } catch (error) {
        this.error = error.message || "Erro ao registrar número na Meta";
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
